import { useState, useEffect } from 'react'
import { useStore } from 'react-redux'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import _ from 'lodash'

import { Card } from '@mui/material'

import { ListDisplay } from '../../Component/ListDisplay/ListDisplay'

import { constants } from '../../Constants/constants'
import { getList } from '../../helper/baseFetch'
import { getParamQueryString, getQuery, getQueryParamObject } from '../../helper/util'
import { getPayloadWithHyperLink } from './surveyMappingUtil'

const resource = 'survey'

export const SurveyMappingList = ({ changeUrlQueryString }) => {

  const store = useStore()
  const history = useHistory()
  const location = useLocation()
  const filterParams = getQuery()
  const params = useParams()

  const [surveyMappingList, setSurveyMappingList] = useState([])
  const [ready, setReady] = useState(false)

  const surveyMappingTitleList = [
    {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: 'surveyId',
      newTabHyperLink: true,
      sort: false,
    },
    {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: 'refCode',
      sort: true,
    },
    {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: 'refType',
      sort: true,
    },
    {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: 'serviceType',
      sort: true,
    },
    {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: 'surveyType',
      sort: true,
    },
    {
      key: constants.LIST_DISPLAY_TYPE.DATE_TIME,
      value: 'startTimestamp',
      sort: true,
    },
    {
      key: constants.LIST_DISPLAY_TYPE.DATE_TIME,
      value: 'endTimestamp',
      sort: true,
    },
    {
      key: constants.LIST_DISPLAY_TYPE.BOOLEAN,
      value: 'mandatory',
      sort: false,
    },
    {
      key: constants.LIST_DISPLAY_TYPE.STATUS,
      value: 'status',
      sort: false,
    },
  ]

  const listFilters = [
    // {
    //   className: 'filter-input',
    //   label: { resource: resource, key: 'refType' },
    //   clear: true,
    //   value: '',
    //   type: constants.TYPE.SELECT,
    //   selectValue: constants.CHOICES.SURVEY.REF_TYPE,
    //   name: 'refType',
    //   size: constants.SIZE.SMALL,
    // },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'serviceType' },
      value: '',
      type: constants.TYPE.SELECT,
      selectValue: constants.CHOICES.SURVEY.SERVICE_TYPE,
      name: 'serviceType',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'surveyType' },
      clear: true,
      value: '',
      type: constants.TYPE.SELECT,
      selectValue: constants.CHOICES.SURVEY.SURVEY_TYPE,
      name: 'surveyType',
      size: constants.SIZE.SMALL,
    },
    // {
    //   className: 'filter-input',
    //   label: { resource: resource, key: 'status' },
    //   clear: true,
    //   value: '',
    //   type: constants.TYPE.SELECT,
    //   selectValue: constants.CHOICES.SURVEY.STATUS,
    //   name: 'status',
    //   size: constants.SIZE.SMALL,
    // },
  ]

  const [param, setParam] = useState(
    !changeUrlQueryString
      ? {
        path: '',
        page: 0,
        rowsPerPage: 10,
        sort: 'updateTimestamp',
        direction: 'DESC',
        listFilters: _.cloneDeep(listFilters),
        count: 0,
      }
      : getQueryParamObject(
        {
          path: '',
          page: 0,
          rowsPerPage: 10,
          sort: 'updateTimestamp',
          direction: 'DESC',
          listFilters: _.cloneDeep(listFilters),
          count: 0,
        },
        _.cloneDeep(listFilters),
        surveyMappingTitleList
      )
  )

  useEffect(() => {
    if (!changeUrlQueryString) {
      return
    }

    const querySyring = getParamQueryString(
      {
        path: '',
        page: 0,
        rowsPerPage: 10,
        sort: 'updateTimestamp',
        direction: 'DESC',
        listFilters: _.cloneDeep(listFilters),
        count: param.count,
      },
      param
    )

    const currentQueryString = window.location.search?.substring(1)

    if (querySyring === currentQueryString) {
      return
    }

    const newParam = getQueryParamObject(
      {
        path: '',
        page: 0,
        rowsPerPage: 10,
        sort: 'updateTimestamp',
        direction: 'DESC',
        listFilters: _.cloneDeep(listFilters),
        count: param.count + 1,
      },
      _.cloneDeep(listFilters),
      surveyMappingTitleList
    )

    setParam(newParam)

    const newQuery = getParamQueryString(
      {
        path: '',
        page: 0,
        rowsPerPage: 10,
        sort: 'updateTimestamp',
        direction: 'DESC',
        listFilters: _.cloneDeep(listFilters),
        count: 0,
      },
      newParam
    )

    history.replace({ pathname: location.pathname, search: newQuery })
  }, [filterParams])

  function onChangeParam(value) {
    value.count = value.count + 1

    if (!changeUrlQueryString) {
      setParam(value)
      return
    }

    const querySyring = getParamQueryString(
      {
        path: '',
        page: 0,
        rowsPerPage: 10,
        sort: 'updateTimestamp',
        direction: 'DESC',
        listFilters: _.cloneDeep(listFilters),
        count: 0,
      },
      value
    )

    history.push({ pathname: location.pathname, search: querySyring })
  }

  function onChangeListFilters(list) {
    let tempParam = _.cloneDeep(param)
    tempParam.listFilters = list
    tempParam.page = 0
    onChangeParam(tempParam)
  }

  function onChangeListSort(sortItem) {
    let tempParam = _.cloneDeep(param)
    tempParam.sort = sortItem
    tempParam.direction = tempParam.direction === 'DESC' ? 'ASC' : 'DESC'
    onChangeParam(tempParam)
  }

  function onChangeListPage(page) {
    let tempParam = _.cloneDeep(param)
    tempParam.page = page
    onChangeParam(tempParam)
  }

  function onChangeListRowsPerPage(rowsPerPage) {
    let tempParam = _.cloneDeep(param)
    tempParam.page = 0
    tempParam.rowsPerPage = rowsPerPage
    onChangeParam(tempParam)
  }

  useEffect(() => {

    let tempParam = _.cloneDeep(param)

    const filter = { restUrlId: params.id }
    tempParam.listFilters.forEach((filterItem) => {
      if (filterItem.value !== '' && filterItem.value !== undefined) {
        filter[filterItem.name] = filterItem.value
      }
    })

    getList(
      constants.PATH.SURVEY.RESTAURANT_SURVEY_MAP,
      {
        // sort: { field: tempParam.sort, order: tempParam.direction },
        sort: {},
        filter: filter,
        pagination: { page: tempParam.page + 1, perPage: tempParam.rowsPerPage },
      },
      (payload) => {
        const sortedPayloadWithHyperLink = getPayloadWithHyperLink(payload)
        setSurveyMappingList(sortedPayloadWithHyperLink)
        setReady(true)
      },
      undefined,
      store
    )
  }, [param.count]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    ready && (
      <Card className="card-wrapper overflow">
        <ListDisplay
          page={param.page}
          rowsPerPage={param.rowsPerPage}
          onChangeListSort={onChangeListSort}
          resource={resource}
          dataList={surveyMappingList}
          sort={param.sort}
          direction={param.direction}
          listTitles={surveyMappingTitleList}
          listFilters={param.listFilters}
          idName="id"
          onChangeListPage={onChangeListPage}
          onChangeListRowsPerPage={onChangeListRowsPerPage}
          onChangeListFilters={onChangeListFilters}
          useRedirectPathStraight
          redirectCreatePath={`/${constants.PATH.SURVEY.RESTAURANT_SURVEY_MAP}/create/${params.id}/0`}
          editRedirectPath={`/${constants.PATH.SURVEY.RESTAURANT_SURVEY_MAP}/edit/${params.id}/`}
          createBtn={true}
          editBtn={true}
        />
      </Card>
    )
  )
}
